import { supabase } from '../supabaseClient';

export const linkAnonymousAccount = async (email, password) => {
  const { data: { user }, error: userError } = await supabase.auth.getUser();
  if (userError) throw userError;
  if (!user?.is_anonymous) {
    throw new Error('An active anonymous account is required to link a login.');
  }

  const anonymousUserId = user.id;
  const { data, error } = await supabase.auth.updateUser(
    { email, password },
    { emailRedirectTo: `${window.location.origin}/` }
  );
  if (error) throw error;
  if (data.user?.id !== anonymousUserId) {
    throw new Error('Account linking did not preserve the current user. Please contact support.');
  }

  return data.user;
};

export const signInWithEmail = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: email.trim().toLowerCase(),
    password,
  });
  if (error) throw error;
  return data.user;
};

export const sendPasswordReset = async (email) => {
  const { error } = await supabase.auth.resetPasswordForEmail(
    email.trim().toLowerCase(),
    { redirectTo: `${window.location.origin}/?auth=recovery` }
  );
  if (error) throw error;
};

export const updateRecoveredPassword = async (password) => {
  const { data, error } = await supabase.auth.updateUser({ password });
  if (error) throw error;
  return data.user;
};

export const continueAnonymously = async (captchaToken) => {
  if (!captchaToken) throw new Error('Complete the CAPTCHA challenge before continuing.');
  const { data, error } = await supabase.auth.signInAnonymously({
    options: { captchaToken },
  });
  if (error) throw error;
  localStorage.setItem('senditmaxx_force_migration', 'true');
  return data.user;
};
